import React, { useEffect, useState } from 'react';

const TableOfContents = ({ className = '' }) => {
  const [tocItems, setTocItems] = useState([]);
  const [activeId, setActiveId] = useState('');

  useEffect(() => {
    // Find all h2 and h3 elements and build TOC
    const headings = document.querySelectorAll('h2, h3');
    const items = [];

    headings.forEach((heading, index) => {
      const level = parseInt(heading.tagName.charAt(1));
      let id = heading.id;
      
      // Generate ID if not present
      if (!id) {
        id = heading.textContent
          ?.toLowerCase()
          .replace(/[^\w\s-]/g, '')
          .replace(/\s+/g, '-') || `heading-${index}`;
        heading.id = id;
      }

      items.push({
        id,
        text: heading.textContent || '',
        level
      });
    });

    setTocItems(items);

    // Set up intersection observer for active section tracking
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveId(entry.target.id);
          }
        });
      },
      { rootMargin: '-20% 0% -35% 0%' }
    );

    headings.forEach((heading) => observer.observe(heading));

    return () => observer.disconnect();
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - 80; // 80px for fixed header
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  };

  if (tocItems.length === 0) return null;

  return (
    <nav className={`bg-[#fbf6f3] rounded-lg p-6 ${className}`}>
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Table of Contents</h3>
      <ul className="space-y-2">
        {tocItems.map((item) => (
          <li key={item.id} className={item.level === 3 ? 'ml-4' : ''}>
            <button
              onClick={() => scrollToSection(item.id)}
              className={`text-left w-full text-sm hover:text-[#ab3d22] transition-colors ${
                activeId === item.id 
                  ? 'text-[#ab3d22] font-medium' 
                  : 'text-gray-600'
              }`}
            >
              {item.text}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default TableOfContents;
